import actions from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  accessToken: "",
};

export default function assessmentReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_LOGIN:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
